// import Index from './Index.vue'
import Permissions from "../../models/Permissions";

const Index = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

export default [
  {
    path: "/destda",
    name: "DeSTDA",
    component: Index,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      showInMenu: true,
      label: "DeSTDA",
      icon: "fa fa-files-o",
      group: "SPEDS / DeSTDA",
      permissions,
    },
  },
];
